import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map } from "lodash";
import Grid from "@material-ui/core/Grid";

import DatePicker from "../../Common/DatePicker";
import CustomSelect from "../../Common/CustomSelect";
import { formatDateLabel } from "../../../utils/date";

const RecurrenceEnds = (props) => {
  const { classes, formValues, changeParam } = props;

  return (
    <Grid item className={classes.row}>
      <Grid container alignItems="center">
        <Grid item className={classes.label}>
          {I18n.get("scheduler_ends")}
        </Grid>
        <Grid item style={{ width: "100px" }}>
          <CustomSelect
            name="ends1"
            value={get(formValues, ["recurrence", "ends"])}
            onChange={(e) => changeParam("ends", null, e.target.value)}
            options={map(
              [
                {
                  code: "on",
                  name: I18n.get("scheduler_on"),
                },
              ],
              (item) => ({
                id: item.code,
                name: item.name,
              })
            )}
            noSort
          />
        </Grid>
        {get(formValues, ["recurrence", "ends"]) === "on" ? (
          <Grid item style={{ paddingLeft: "10px" }}>
            <DatePicker
              name="endsOn"
              value={get(formValues, ["recurrence", "endsOn"])}
              onChange={(name, date) => changeParam("endsOn", null, date)}
              dateOnly
              formatLabel={formatDateLabel}
              style={{ marginBottom: 0 }}
            />
          </Grid>
        ) : get(formValues, ["recurrence", "ends"]) === "after" ? (
          <>
            <Grid item style={{ paddingLeft: "10px", width: "80px" }}>
              <CustomSelect
                name="endsAfter"
                value={get(formValues, ["recurrence", "endsAfter"])}
                onChange={(e) => changeParam("endsAfter", null, e.target.value)}
                options={map(
                  map(new Array(99), (item, index) => index + 1),
                  (item) => ({
                    id: item,
                    name: item,
                  })
                )}
                noSort
              />
            </Grid>
            <Grid item style={{ paddingLeft: "10px" }}>
              {I18n.get("scheduler_occurrences")}.
            </Grid>
          </>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default RecurrenceEnds;
